import { render, staticRenderFns } from "./profitChart.vue?vue&type=template&id=bbb1ab34&scoped=true"
import script from "./profitChart.vue?vue&type=script&lang=js"
export * from "./profitChart.vue?vue&type=script&lang=js"
import style0 from "./profitChart.vue?vue&type=style&index=0&id=bbb1ab34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb1ab34",
  null
  
)

export default component.exports